export default {"src":"/_next/static/media/close-menu-grey.a42b2a4e.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};